import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiError } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name:"", email:"", password:"" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account creato. Benvenuto!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Errore registrazione");
    } finally { setLoading(false); }
  };
  return (
    <div className="pt-32 pb-24 min-h-[80vh]" data-testid="register-page">
      <div className="container-editorial grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-5">
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#2d6fc4]">— Nuovo account</p>
          <h1 className="font-serif text-5xl md:text-6xl mt-4 leading-[0.9]">
            Crea il tuo <em className="italic text-[#2d6fc4]">accesso riservato</em>.
          </h1>
          <p className="mt-6 text-[#333333] max-w-md">
            L'area clienti è pensata per chi ha già avviato una pratica con noi — o vuole cominciare in modo strutturato.
          </p>
        </div>
        <form onSubmit={submit} className="col-span-12 md:col-span-6 md:col-start-7 border border-[#E5E7EB] bg-[#FFFFFF] rounded-lg p-8 md:p-10 space-y-6" data-testid="register-form">
          <label className="block">
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#333333]">Nome e cognome</span>
            <input required data-testid="reg-name" className="w-full bg-transparent border-b border-[#E5E7EB] py-3 focus:border-[#14417B]" value={form.name} onChange={e=>setForm({...form, name:e.target.value})}/>
          </label>
          <label className="block">
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#333333]">Email</span>
            <input required type="email" data-testid="reg-email" className="w-full bg-transparent border-b border-[#E5E7EB] py-3 focus:border-[#14417B]" value={form.email} onChange={e=>setForm({...form, email:e.target.value})}/>
          </label>
          <label className="block">
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#333333]">Password (min 6 caratteri)</span>
            <input required type="password" minLength={6} data-testid="reg-password" className="w-full bg-transparent border-b border-[#E5E7EB] py-3 focus:border-[#14417B]" value={form.password} onChange={e=>setForm({...form, password:e.target.value})}/>
          </label>
          <button disabled={loading} data-testid="reg-submit" className="btn-terracotta w-full py-4 rounded-lg text-sm tracking-wide disabled:opacity-60">
            {loading ? "Creazione…" : "Crea account"}
          </button>
          <p className="text-sm text-[#333333]">
            Hai già un account? <Link to="/login" className="text-[#2d6fc4] link-underline pb-0.5">Accedi</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
